import { useState } from "react";
import { Client, Scheme } from "creso-core/types";
import { GiftAmcSelection } from "./gift-amc-selection";
import { GiftAmc } from "../constants";
import { GiftSchemeAmountStep } from "./gift-scheme-amount-step";
import { GiftPaymentSummary } from "./gift-payment-summary";

type FlowState =
  | { step: 1 }
  | { step: 2; amc: GiftAmc; folioNumber: string }
  | {
      step: 3;
      amc: GiftAmc;
      folioNumber: string;
      scheme: Scheme<"all">;
      amount: number;
    };

export function GiftOutboundTransaction({ client }: { client: Client }) {
  const [state, setState] = useState<FlowState>({ step: 1 });

  if (state.step === 2) {
    return (
      <GiftSchemeAmountStep
        amc={state.amc}
        folioNumber={state.folioNumber}
        onBack={() => setState({ step: 1 })}
        onProceed={({ scheme, folioNumber, amount }) =>
          setState({ step: 3, amc: state.amc, folioNumber, scheme, amount })
        }
        client={client}
      />
    );
  }

  if (state.step === 3) {
    return (
      <GiftPaymentSummary
        client={client}
        scheme={state.scheme}
        amount={state.amount}
        folioNumber={state.folioNumber}
        onBack={() =>
          setState({ step: 2, amc: state.amc, folioNumber: state.folioNumber })
        }
        onNotified={() => setState({ step: 1 })}
      />
    );
  }

  return (
    <GiftAmcSelection
      client={client}
      onTransact={(amc, folioNumber) => setState({ step: 2, amc, folioNumber })}
    />
  );
}
